import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kitchen-coaching-courses',
  templateUrl: './kitchen-coaching-courses.component.html',
  styleUrls: ['./kitchen-coaching-courses.component.scss']
})
export class KitchenCoachingCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
